import { Plus, X } from "lucide-react";
import { money, airlineGrandTotal } from "./chargeUtils";

const AirlineTabs = ({
  airlines,
  activeIndex,
  onSelect,
  onAdd,
  onRemove,
  airlineNameByCode,
  totalWeight,
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
      {airlines.map((airline, index) => {
        const active = index === activeIndex;
        const label =
          airlineNameByCode(airline.carrierCode) ||
          (airline.carrierCode ? airline.carrierCode : `New airline ${index + 1}`);

        return (
          <div
            key={index}
            onClick={() => onSelect(index)}
            onMouseEnter={(e) => {
              if (!active) e.currentTarget.style.background = "#fff8e7";
            }}
            onMouseLeave={(e) => {
              if (!active) e.currentTarget.style.background = "#fff";
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
              borderRadius: 999,
              padding: "7px 10px 7px 14px",
              fontSize: 12.5,
              fontWeight: 600,
              border: active ? "1px solid #e5a50e" : "1px solid #e5e7eb",
              background: active ? "#FCB614" : "#fff",
              color: active ? "#1f2937" : "#4b5563",
              boxShadow: active ? "0 4px 10px rgba(252,182,20,0.28)" : "none",
              transition: "background 0.15s ease, box-shadow 0.15s ease",
            }}
          >
            <span>{label}</span>
            <span style={{ fontFamily: "monospace", fontWeight: 500, opacity: 0.8 }}>
              {money(airlineGrandTotal(airline, totalWeight))}
            </span>
            {airlines.length > 1 && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(index);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: active ? "#1f2937" : "#9ca3af",
                  opacity: 0.7,
                }}
                title="Remove airline"
              >
                <X size={13} />
              </span>
            )}
          </div>
        );
      })}

      <button
        type="button"
        onClick={onAdd}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          cursor: "pointer",
          border: "1px dashed #d1d5db",
          color: "#FCB614",
          borderRadius: 999,
          padding: "7px 14px",
          fontSize: 12.5,
          fontWeight: 600,
          background: "transparent",
          transition: "background 0.15s ease, border-color 0.15s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#fffbf0";
          e.currentTarget.style.borderColor = "#FCB614";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.borderColor = "#d1d5db";
        }}
      >
        <Plus size={14} />
        Add airline
      </button>
    </div>
  );
};

export default AirlineTabs;
